'use client';
import React from 'react';
import FeaturedArticlesSlider from './new/FeaturedArticlesSlider';
import BlogListing from './new/BlogListing';
import { NudgeCard } from '../ui/new/NudgeCard';
import styles from "./blogpage.module.css"

const BlogPageComponent = ({
}) => {
  return (
    <main className={`${styles.container} flex flex-col gap-16 md:gap-24 pt-32 md:pt-36 text-white`}>
      <div className="mx-auto w-full max-w-[900px] text-center">
        <h1 className="bg-clip-text bg-gradient-to-b from-[#1FBCCB] via-[#1FBCCB] to-[#FFFFFF] pt-5 font-instrument-serif font-bold text-[46px] text-transparent md:text-[66px] text-center italic">
          Our blogs
        </h1>
        <p className="font-inter-tight text-[#999999] text-[15px] md:text-[18px]">
          Explore our real-world achievements, where we turn challenges into
          triumphs. These case studies highlight our track record of delivering
          impactful digital solutions for our clients.
        </p>
      </div>

      <FeaturedArticlesSlider />
      <BlogListing />
      <NudgeCard page='blog' />
    </main>
  );
};

export default BlogPageComponent;
